import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'
import { AccessDenied } from '@/components/ui/AccessDenied'

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, kullanici } = useAuthStore()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (kullanici?.rol !== 'super_admin') {
    return <AccessDenied />
  }

  return <>{children}</>
}
